import { Component, OnInit, OnDestroy } from '@angular/core';
import { PublicEnquiryService } from '../../../services/public-enquiry.service';
import { Subject } from 'rxjs/Subject';
import { Router } from '@angular/router';

@Component({
    selector: 'app-enquiry-home',
    templateUrl: './enquiry-home.component.html',
    styleUrls: ['./enquiry-home.component.css']
})
export class EnquiryHomeComponent implements OnInit, OnDestroy {

    items: Array<any>;
    destroyComponent$ = new Subject();

    constructor(
        private router: Router,
        private service: PublicEnquiryService
    ) { }

    ngOnInit() {
        this.service.getList5().toPromise().then(x => {
            this.items = x.listdata;
        });
    }

    ngOnDestroy(): void {
        this.destroyComponent$.next();
        this.destroyComponent$.complete();
    }

    gotoAll() {
        this.router.navigate(['/price/enquiry-public'], {
            queryParams: { 'date': new Date().getTime() }
        });
    }

}



// WEBPACK FOOTER //
// F:/WMS/X-xiamenzhuhe-SDM234/zhuhe-234/sdm_fe/src/app/home/components/home/enquiry-home/enquiry-home.component.ts